import { type ReactNode, useState } from 'react';
import { cn } from '@dinewise/utils';

export const CopyLinkButton = ({
  url,
  preClickText,
  postClickText,
  classNames,
}: {
  url: string;
  preClickText?: ReactNode | string;
  postClickText?: ReactNode | string;
  classNames?: {
    text?: string;
  };
}) => {
  const [copied, setCopied] = useState(false);

  const preClickTextToDisplay = preClickText ?? 'Copy';
  const postClickTextToDisplay = postClickText ?? 'Copied!';

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <div
      className={cn('cursor-pointer font-medium text-green-800 text-xs', classNames?.text)}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          void copyToClipboard();
        }
      }}
      onClick={() => void copyToClipboard()}
    >
      {copied ? postClickTextToDisplay : preClickTextToDisplay}
    </div>
  );
};
